import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

export const ConnectWallet: React.FC<CardGradientProps> = ({
  className,
  width = "20",
  height = "19",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.3158 1.47266H3.68544C2.75527 1.47266 2.00122 2.2267 2.00122 3.15685V15.2257C2.00122 16.1558 2.75527 16.9099 3.68544 16.9099H16.3158C17.246 16.9099 18 16.1558 18 15.2257V3.15685C18 2.2267 17.246 1.47266 16.3158 1.47266Z"
        stroke="#FFA686"
        stroke-width="2.92905"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.9999 8.45387V15.227C17.9999 16.1565 17.2462 16.9101 16.3168 16.9101H3.6861C2.75473 16.9101 2 16.1551 2 15.224V8.45414C2 7.52575 2.75473 6.77103 3.6861 6.77103H5.9126C6.40992 6.77103 6.85582 7.09763 6.98398 7.57825C7.33994 8.91134 8.55646 9.89385 10.0016 9.89385C11.4467 9.89385 12.6632 8.91134 13.0192 7.57825C13.1476 7.09763 13.5932 6.77103 14.0905 6.77103H16.3168C17.2462 6.77103 17.9999 7.5244 17.9999 8.45387Z"
        fill="#CFB2FF"
        stroke="#CFB2FF"
        stroke-width="2.92905"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
